import React, { useState } from "react";
import { User, LogOut } from "lucide-react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { useAuth } from "../../../context/AuthContext";

const MenuItem = styled.li`
  position: relative;
`;

const UserIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const DropdownMenu = styled.ul`
  font-family: "Nunito";
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
  padding: 10px;
  width: 200px;
  list-style: none;
  z-index: 10;
`;

const DropdownItem = styled.li`
  padding: 8px 16px;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const UserButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #062541;
  font-size: 14px;
  width: 100%;
  padding: 0px;
  outline: none;
  :focus {
    outline: none;
  }
`;

const UserMenu = () => {
  const { logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const history = useHistory();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
    history.push("/profile");
  };

  return (
    <MenuItem>
      <UserIcon onClick={toggleMenu}>
        <User fill="#062541" size={30} />
      </UserIcon>
      <DropdownMenu isOpen={isMenuOpen}>
        <DropdownItem>
          <UserButton type="button" onClick={handleLinkClick}>
            <User size={14} fill="#062541" />
            Mi Perfil
          </UserButton>
        </DropdownItem>
        <DropdownItem>
          <UserButton type="button" onClick={handleLogout}>
            <LogOut size={14} />
            Cerrar Sesión
          </UserButton>
        </DropdownItem>
      </DropdownMenu>
    </MenuItem>
  );
};

export default UserMenu;
